import { Fragment, useState } from "react";
import { updateScriptChunks } from "../api";
import { boundaries, toggleBoundary, words } from "../lib/chunks";
import { btnInk, btnShu } from "./Cram";

const MAX_CHUNK_WORDS = 7;

export function ChunkEditor({ id, chunks, onSaved }: { id: string; chunks: string[]; onSaved: () => void }) {
  const [draft, setDraft] = useState(chunks);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const cuts = boundaries(draft);
  const ws = words(draft);
  const tooLong = draft.some((c) => c.split(/\s+/).length > MAX_CHUNK_WORDS);

  const save = () => {
    setBusy(true);
    updateScriptChunks(id, draft).then(onSaved, (e) => {
      setError(e instanceof Error ? e.message : String(e));
      setBusy(false);
    });
  };

  return (
    <div>
      <p className="text-[12px] text-ink-3">語と語の間をタップすると、区切りを入れたり外したりできます。</p>
      <p className="mt-2 text-[17px] leading-loose">
        {ws.map((w, i) => (
          <Fragment key={i}>
            <span>{w}</span>
            {i < ws.length - 1 && (
              <button
                type="button"
                onClick={() => setDraft((d) => toggleBoundary(d, i))}
                aria-label={cuts.has(i) ? "区切りを外す" : "区切りを入れる"}
                className={`mx-0.5 inline-block w-4 text-center font-bold ${cuts.has(i) ? "text-shu" : "text-rule hover:text-ink-3"}`}
              >
                {cuts.has(i) ? "/" : "·"}
              </button>
            )}
          </Fragment>
        ))}
      </p>
      <div className="mt-3 flex gap-2">
        <button type="button" onClick={save} disabled={busy || tooLong} className={btnShu}>
          {busy ? "保存中…" : "保存して練習に戻る"}
        </button>
        <button type="button" onClick={() => setDraft(chunks)} disabled={busy} className={btnInk}>
          元に戻す
        </button>
      </div>
      {tooLong && <p className="mt-2 text-[12px] font-bold text-shu">1 つのチャンクは 7 語までです。区切りを足してください。</p>}
      {error && <p className="mt-2 text-[12px] font-bold text-shu">{error}</p>}
    </div>
  );
}
